import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'sso-oauth2',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class SSOOAuth2 extends Vue {
    @Prop()
    public isEditAllow: any;

    @Prop()
    public ssoFields: any;

    public isNotObjectResponse: boolean = false;

    public isNotObjectDistrict: boolean = false;

    public onBack() {
        this.$emit('onBack');
    }

    public onEdit() {
        this.$emit('onEdit');
    }

    public onSubmit() {
        this.$emit('onSubmit', this.ssoFields);
    }

    private created() {
        if (this.ssoFields.profile) {
            this.isNotObjectResponse = typeof this.ssoFields.profile.response_mapper === 'object';
            this.isNotObjectDistrict = typeof this.ssoFields.profile.district_mapper === 'object';
        }

    }

}
